import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const KEYFRAMES = `@keyframes kg-page-loading-spin{to{transform:rotate(360deg)}}`;
const SPINNER_DIM = { sm: 18, md: 26, lg: 36 };
/**
 * SVG spinner — no Tailwind dependency; wrap with app text color classes.
 */
export function PageLoadingSpinner({ size = 'md', className, style, accentColor, trackColor = '#e4e4e7', }) {
    const dim = SPINNER_DIM[size];
    const useThemeColor = accentColor == null || accentColor === '';
    return (_jsxs(_Fragment, { children: [_jsx("style", { dangerouslySetInnerHTML: { __html: KEYFRAMES } }), _jsxs("svg", { className: className, width: dim, height: dim, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: {
                    ...style,
                    display: 'block',
                    flexShrink: 0,
                    animation: 'kg-page-loading-spin 0.9s linear infinite',
                    ...(useThemeColor ? { color: 'inherit' } : { color: accentColor }),
                }, "aria-hidden": true, children: [_jsx("circle", { cx: "12", cy: "12", r: "10", stroke: useThemeColor ? 'currentColor' : trackColor, strokeWidth: "4", strokeOpacity: useThemeColor ? 0.25 : 1 }), _jsx("path", { fill: useThemeColor ? 'currentColor' : accentColor, fillOpacity: useThemeColor ? 0.85 : 1, d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] })] }));
}
const LAYOUT = {
    page: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 'min(42vh, 260px)',
        gap: 14,
        padding: '24px 16px',
        boxSizing: 'border-box',
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: 12,
        padding: '36px 16px',
        boxSizing: 'border-box',
    },
    inline: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: '8px 4px',
        boxSizing: 'border-box',
    },
    fullscreen: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: '100vh',
        gap: 16,
        padding: 24,
        boxSizing: 'border-box',
    },
};
const SPINNER_FOR_VARIANT = {
    page: 'lg',
    section: 'md',
    inline: 'sm',
    fullscreen: 'lg',
};
/**
 * Standard loading state for portals (agent / shop / super-agent / admin).
 */
export function PageLoadingIndicator({ label = 'Loading...', variant = 'page', className, style, accentColor = '#E8551F', trackColor, labelHidden = false, spinnerClassName, labelClassName, }) {
    const layout = LAYOUT[variant];
    const spinnerSize = SPINNER_FOR_VARIANT[variant];
    const useThemeSpinner = variant === 'fullscreen';
    const labelStyle = {
        fontSize: variant === 'fullscreen' ? 16 : 14,
        fontWeight: 500,
        textAlign: 'center',
        lineHeight: 1.45,
        maxWidth: 320,
        ...(labelClassName ? {} : { color: '#71717a' }),
    };
    return (_jsxs("div", { role: "status", "aria-live": "polite", "aria-busy": "true", "aria-label": labelHidden ? undefined : label, className: className, style: { ...layout, ...style }, children: [_jsx(PageLoadingSpinner, { className: spinnerClassName, size: spinnerSize, accentColor: useThemeSpinner ? undefined : accentColor, trackColor: trackColor }), !labelHidden && label ? (_jsx("span", { className: labelClassName, style: labelStyle, children: label })) : null] }));
}
